$(document).ready(function(){
  let headerH = $('.header-wrapper').height();
  let adjust = - headerH;
  let time = 500;
  let urlHash = location.hash;
  if(urlHash) {
    $('body,html').stop().scrollTop(0);
    setTimeout(function () {
      scrollToAnker(urlHash) ;
    }, 100);
  }
  $('a[href^="#"].smooth').not('.tab a').on('click', function(event) {
    event.preventDefault();
    let decodedHash = decodeURI(this.hash);
    console.log(decodedHash);
    let hash = decodedHash == "#" || decodedHash == "" ? 'html' : decodedHash;
    scrollToAnker(hash);
    return false;
  });
  function scrollToAnker(hash) {
    let target = $(hash);
    let position = target.offset().top + adjust;
    $('body,html').stop().animate({scrollTop:position}, time, 'swing');
  }
});

$(function(){
  $('#aw-announcement-bar').slick({
    fade: true,
    infinite: true 
  });
});